<template>
    <div>
      <v-row class="pa-5 pb-2">
        <!-- <v-headline class="font-weight-bold">{{ headerText }}</v-headline> -->
        <p class="font-weight-bold">{{ headerText }}</p>
      </v-row>
      <v-row class="px-4 mb-4">
        <v-divider></v-divider>
      </v-row>
    </div>
</template>
  
<script>
  export default {
    name: 'HeaderDividerBlock',
    props: {
      headerText: {
        type: String,
        required: true,
      },
    },
   
  }
</script>
  

  